export default __webpack_public_path__ + "assets/resizedlaval.76530600.webp";